import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth, hasRole } from '@/lib/auth';
import { CampaignList } from '@/components/campaigns/CampaignList';
import { CampaignDetail } from '@/components/campaigns/CampaignDetail';

export default function CampaignsPage() {
  const [params, setParams] = useSearchParams();
  const { user } = useAuth();
  const id = params.get('id');
  const canAct = hasRole(user, ['admin', 'tech']);
  if (id) {
    return <CampaignDetail id={id} canAct={canAct} isAdmin={user?.role === 'admin'} onBack={() => setParams({})} />;
  }
  return <CampaignList canAct={canAct} onOpen={(cid) => setParams({ id: cid })} />;
}
